import { Box, Paper, Typography } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";
import ManualLink from "../../components/ManualLink";

// `manual` = { settlementType, section }: a discreet link to the page of the
// user manual that explains this screen (behind-the-meter and merchant
// projects only; nothing is shown for other revenue models).
export default function FeasibilityShell({ title, subtitle, headerAside = null, compact = false, maxWidth = 1280, manual = null, children }) {
  const { t, translateText } = useLanguage();

  return (
    <Box
      sx={{
        pt: { xs: 0.2, md: 0.4 },
        px: { xs: 0, md: 0 },
        pb: 2,
        ...(compact && {
          width: "100%", maxWidth, minWidth: 0,
          typography: "body2",
          "& .MuiFormHelperText-root": { typography: "caption", mt: 0.5 },
          "& .MuiFormControlLabel-label, & .MuiAlert-message": { typography: "body2" },
          "& .MuiChip-label": { typography: "caption" },
        }),
      }}
    >
      <Paper elevation={compact ? 0 : 1} variant={compact ? "outlined" : undefined} sx={{ p: 1.5, mb: compact ? 1.25 : 1.5, borderRadius: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: { xs: "flex-start", lg: "flex-start" },
            justifyContent: "space-between",
            gap: 1.5,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant={compact ? "overline" : "body2"}
              sx={{
                fontWeight: 600,
                color: "text.secondary",
                textTransform: "uppercase",
                letterSpacing: 0.5,
                mb: 0.5,
              }}
            >
              {t("nav.feasibilityStudy")}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", columnGap: 1.5, rowGap: 0.5, mb: compact ? 0.5 : 0.75 }}>
              <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>
                {translateText(title)}
              </Typography>
              {manual ? <ManualLink settlementType={manual.settlementType} section={manual.section} /> : null}
            </Box>
            {subtitle && (
              <Typography variant="body2" sx={{ fontWeight: 400, color: "text.primary" }}>
                {translateText(subtitle)}
              </Typography>
            )}
          </Box>
          {headerAside ? (
            <Box sx={{ width: { xs: "100%", lg: "auto" }, alignSelf: { xs: "stretch", lg: "center" } }}>
              {headerAside}
            </Box>
          ) : null}
        </Box>
      </Paper>
      <Box sx={{ mt: compact ? 1.25 : 1.5 }}>{children}</Box>
    </Box>
  );
}
